import { graphql } from "api/cms-website/generated";

export const ClinicsListFragment = graphql(/* GraphQL */ `
    fragment ClinicsListFragment on ComponentComponentsClinicsList {
        id
        titleForFirstList
        titleForSecondList
        titleForThirdList
        disclaimerForSecondList
        noMarginBottom
    }
`);
